import { getSubDomain } from "../helper";

/// @ts-ignore

const BACKEND = process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_LOCAL_BE === 'TRUE'
  ? 'http://localhost:3080'
  : 'https://backend.' + getSubDomain();

export const MENU = `${BACKEND}/getMenu/`;
export const TRANSLATION = `${BACKEND}/translation`;
export const LANGUAGES = `${BACKEND}/languages`;
export const RESOURCE = `${BACKEND}/resource/`;
export const RESOURCEDETAIL = `${BACKEND}/resourcedetail/`;
export const SCHEMA = `${BACKEND}/getSchema`;
export const CREATERESOURCE = `${BACKEND}/newresource`;
export const COMPONENT_ROUTE = `${BACKEND}/getComponentRoute/`;
export const ENTITY_ID = `${BACKEND}/entity/secret`;
export const REGISTRATION_FORM = `${BACKEND}/getRegistrationForm`;
export const REGISTRATION = `${BACKEND}/registration`;
export const SYNC_EVENT = `${BACKEND}/synchronization`;
export const ENTITIES = `${BACKEND}/getEntities`;
export const LOGOUT = `${BACKEND}/backend/logout`;
export const USERS = `${BACKEND}/getAzureUsers`;
export const TOOLTIPS = `${BACKEND}/gettips/203762`;